import ImDesa from 'assets/images/im-desacerdas.png'

export default function DetailDesaCerdas() {
  return (
    <div className="items-center px-8 mt-20 bg-white lg:mt-0 lg:space-y-16 md:space-x-10 lg:space-x-0 lg:py-36 wrapper xl:px-99 md:flex md:justify-center">
      <div className="hidden md:w-1/2 imagewrapper md:block">
        <img
          src={ImDesa}
          alt="Geulanggang-Panah Geulanggang-Panah by yeedevstudio"
          className="mt-8 w-[900px] h-[280px]"
        />
      </div>
      <div className="space-y-6 md:w-1/2 detailWrapper ">
        <h1 className="text-xl font-bold">Apa itu Geulanggang-Panah?</h1>
        <p className="text-justify text-cardText">
          Geulanggang-Panah adalah inisiatif komunitas untuk membangun negeri melalui
          bagian paling penting; yaitu desa.
        </p>
        <p className="text-justify text-cardText">
          Platform dan inisiatif ini dimulai dan dikembangkan oleh{" "}
          <span
            className="font-medium underline cursor-pointer"
            onClick={() => (window.location.href = "http://yeedev.id/")}
          >
            YEEDEV STUDIO
          </span>
          , tapi perubahan sesungguhnya ada di tangan kamu para implementor
          penggerak desa.{" "}
        </p>
        <p className="text-justify text-cardText">
          Ajak desa kamu menjadi Geulanggang-Panah bersama-sama
        </p>
      </div>
    </div>
  );
}
